import React, { useState, useEffect } from "react";
import { DownArrow } from "../../assets";

const ScrollLink = ({ title, href }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className="flex flex-row items-center cursor-pointer mb-6 group"
    >
      <span className="text-primary font-medium uppercase mr-2 pb-1 border-b-2 border-transparent group-hover:border-primary transition-border duration-200">
        {title}
      </span>
      <DownArrow className="transition-transform duration-500 ease-in-out group-hover:translate-y-1 mb-2" />
    </a>
  );
};

const Navigation = ({ t, hasTopCandidate, hasSonndesfro, hasElections }) => {
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    // Check if user-agent indicates WebView and update state
    setIsWebView(navigator.userAgent.includes(";wv)"));
  }, []);

  if (!isWebView) {
    return (
      <div className="px-[15%] hidden md:flex md:flex-row justify-between my-6">
        {hasTopCandidate && (
          <ScrollLink
            href="#top-candidate-details"
            t={t}
            title={t("topCandidate")}
          />
        )}
        {hasElections && (
          <ScrollLink href="#results" t={t} title={t("results")} />
        )}
        {hasSonndesfro && (
          <ScrollLink href="#sonndesfro" t={t} title={t("sonndesfro")} />
        )}
      </div>
    );
  }
  return null;
};

export default Navigation;
